import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import firebase from 'lib/firebase';
import { Container, Col, Row } from 'react-bootstrap';
import './AdminStyle.css';
import * as AdminActions from 'store/modules/AdminModule';
import NavScreen from './NavScreen';
import WorkbookScreen from './WorkbookScreen';
import PaidRegisterScreen from './PaidRegisterScreen';
import FilesScreen from './FilesScreen';

class AdminScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sLogin: false,
            gnbIdx: 0,
        }
    }


    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(function (user) {
            let email = user.email;
            let regAdmin = /@boomco.org/;
            let checkAdmin = regAdmin.test(email)

            if(checkAdmin){
                self.setState({ isLogin: true })
            }
        });
    }

    onClickLogin = () => {
        const self = this;

        var provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider).then(function (result) {
            
        }).catch(function (error) {
            console.log("login err", error)
        });
    }

    onClickGnb = (idx) => {
        this.setState({
            gnbIdx: idx,
        });
    }


    render() {
        if (!this.state.isLogin) {
            return (
                <div className="wrapper">
                    <div className="is-input-group" style={{ textAlign: 'center' }}>
                        <a onClick={this.onClickLogin}>
                            <img src="/write/btn_google_signin_light_normal_web.png" alt="" />
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div id="admin">
                <div id='innerAdmin'>
                    <Row>
                        <Col md={2} style={{ background: '#97d4e7' }}>
                            <NavScreen
                                gnb={this.state.gnbIdx}
                                countLevelAll={this.state.allCount}
                                countLevel01={this.state.level1Count}
                                countLevel02={this.state.level2Count}
                                onClickGnb={this.onClickGnb} />
                        </Col>
                        <Col md={10}>
                            {this.state.gnbIdx == 0 ?
                                <WorkbookScreen
                                    countLevelAll={this.state.allCount}
                                    countLevel01={this.state.level1Count}
                                    countLevel02={this.state.level2Count} />
                            : this.state.gnbIdx == 6 ?
                                <PaidRegisterScreen />
                            : <FilesScreen /> 
                            }
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}



let mapStateToProps = (state) => ({
    // adminWorkbookList: JSON.parse(JSON.stringify(state.AdminModule.get('adminWorkbookList')))
});

let mapDispatchToProps = (dispatch) => ({
    // adminActions: bindActionCreators(AdminActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminScreen);

